import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowForward = () => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13H16.86L13.23 17.36C12.8765 17.7853 12.9347 18.4165 13.36 18.77C13.7853 19.1235 14.4165 19.0653 14.77 18.64L19.77 12.64C19.8036 12.5923 19.8337 12.5421 19.86 12.49C19.86 12.44 19.91 12.41 19.93 12.36C19.9753 12.2453 19.9991 12.1233 20 12V12C19.9991 11.8767 19.9753 11.7547 19.93 11.64C19.93 11.59 19.88 11.56 19.86 11.51C19.8337 11.4579 19.8036 11.4077 19.77 11.36L14.77 5.36V5.36C14.5796 5.13146 14.2974 4.99952 14 5V5C13.7663 4.99955 13.5399 5.08092 13.36 5.23L13.36 5.23C12.9348 5.58249 12.8759 6.21291 13.2284 6.63808C13.2289 6.63872 13.2295 6.63936 13.23 6.64L16.86 11H5C4.44771 11 4 11.4477 4 12C4 12.5523 4.44771 13 5 13L5 13Z"
  })
});